import { render, staticRenderFns } from "./IconWallet.vue?vue&type=template&id=2cf745fd"
import script from "./IconWallet.vue?vue&type=script&lang=js"
export * from "./IconWallet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports